import _ from "lodash";
import { TimelineMax, TweenLite, Linear, CSSPlugin } from "gsap/all";
// Imports MUST come from gsap/all, or it will import everything!
// Also, CSSPlugin is used in everything, so import it even though it isn't directly used.
// See: https://greensock.com/forums/topic/18437-import-from-gsap-vs-from-gsapall/
// Ensure modules don't get dropped by tree-shaking
const activatedGsapModules = [
    TimelineMax,
    TweenLite,
    Linear,
    CSSPlugin
];
console.log(activatedGsapModules);

export const createTimeline = function(_v){
  console.log("createTimeline")
  if(_v.timeline){
    console.log("Kill timeline");
    _v.timeline.remove();
    _v.timeline.kill();
  }
  _v.timeline = new TimelineMax({paused: true});
  //this.timeline.duration(173);
  //window.timeline = this.timeline;
  var slideElements = _v.$el.getElementsByClassName('images');
  _.each(slideElements, (el, idx) => {
    // There are the same number of elements as are slides in slideArray.
    // Add background color.
    el.style.backgroundColor = _v.backgroundColor;
    // Add Tween.
    var inPoint = (_v.slideArray[idx].timing / 1000);
    var transitionTime = _v.transitionTime;
    if(idx===0){
      transitionTime = 0;
    }
    _v.timeline.add(
      TweenLite.to(el,
                   transitionTime,
                   {
                     opacity: 1,
                     ease:Linear.easeNone,
                     onComplete:_v.checkSyncAudioAndTimeline
                   }),
      inPoint
    );
  });
  // Lowerthirds.
  var lowerthirdElements = _v.$el.getElementsByClassName('lowerthirds');
  _.each(lowerthirdElements, (el, idx) => {
    // Add Tween.
    var inPoint = _v.lowerthirdsArray[idx].inpoint;
    var duration = _v.lowerthirdsArray[idx].duration;
    var transitionTime = _v.transitionTime;
    _v.timeline.add(
      TweenLite.to(el,
                   transitionTime,
                   {
                     opacity: 1,
                     ease:Linear.easeNone,
                     onComplete:_v.checkSyncAudioAndTimeline
                   }),
      inPoint
    );
    _v.timeline.add(
      TweenLite.to(el,
                   transitionTime,
                   {
                     opacity: 0,
                     ease:Linear.easeNone,
                     onComplete:_v.checkSyncAudioAndTimeline
                   }),
      inPoint + duration
    );
  });

  _v.checkSyncAudioAndTimeline(); // Immediately check, in case it's being redrawn from editing.
  _v.timeUpdate();

  if(_v.timeDeltaWatcherInt){
    clearInterval(_v.timeDeltaWatcherInt);
  }
  _v.timeDeltaWatcherInt = setInterval(function(){
    _v.checkSyncAudioAndTimeline();
  }, 1000);
}
